Wee.routes.map({
	'$any:once': 'guide',
	'$any': 'guide:setup'
});